import React, { useEffect, useState } from "react";
import * as RB from "react-bootstrap";
import { useDispatch } from "react-redux";
import { useLoader } from "../../../Loader";
import * as utils from "../../../Utils/comman";
import DatePicker from "react-datepicker";
import Multiselect from "multiselect-react-dropdown";
import Select from "react-select";

function OnBoardInfo({
  formData,
  handleInputChange,
  setFormData,
  props,
  isEdit,
}) {
  const [role, setRole] = useState([]);
  const [department, setDepartment] = useState([]);
  const dispatch = useDispatch();
  const { startLoader, stopLoader } = useLoader();
  const [manager, setManager] = useState([]);
  const [onboardPlan, setOnboardPlan] = useState([
    { id: 1, planName: "Plan 1" },
    { id: 2, planName: "Plan 2" },
    { id: 3, planName: "Plan 3" },
  ]);
  const [welcomeKit, setWelcomeKit] = useState([]);
  const [itSetup, setItSetup] = useState([]);

  const [selectedPlan, setSelectedPlan] = useState(null);
  const [selectedKit, setSelectedKit] = useState(null);
  const [selectedIt, setSelectedIt] = useState(null);
  const [holidayGroups, setHolidayGroups] = useState([]);

  useEffect(() => {
    getRoleList();
    getDepartmentList();
    getManagerList();
    // getOnboardPlanList();
    getWelcomeKitList();
    getItSetupList();
  }, []);

  useEffect(() => {
    utils
      .callAPI("get", "/leave/holiday/group-list")
      .then((res) => {
        if (res && res.result && res.result.length > 0) {
          setHolidayGroups(res.result);
        }
      })
      .catch((err) => {
        console.error("Error fetching holiday groups:", err);
      });
  }, []);

  const getRoleList = () => {
    startLoader();
    utils
      .callAPI("get", `/role/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const active = res.result.filter((item) => item.isActive === "1");

          setRole(active);
          stopLoader();
        } else {
          stopLoader();
          setRole([]);
        }
      })
      .catch((err) => {
        stopLoader();
        setRole([]);
      });
  };

  const getDepartmentList = () => {
    startLoader();
    utils
      .callAPI("get", `/department/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const active = res.result.filter((item) => item.isActive === "1");
          setDepartment(active);
          stopLoader();
        } else {
          setDepartment([]);
          stopLoader();
        }
      })
      .catch((err) => {
        setDepartment([]);
        stopLoader();
      });
  };

  const getManagerList = () => {
    startLoader();
    utils
      .callAPI("get", `/employee/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const activeItems = res.result.filter(
            (item) => item.isActive === "1"
          );
          setManager(activeItems);
          stopLoader();
        } else {
          setManager([]);
          stopLoader();
        }
      })
      .catch((err) => {
        setManager([]);
        stopLoader();
      });
  };

  const getOnboardPlanList = () => {};

  const getWelcomeKitList = () => {
    startLoader();
    utils
      .callAPI("get", `/employee/welcomekit/list`)
      .then((res) => {
        if (typeof res !== "undefined") {
          const activeItems = res.result.filter(
            (item) => item.isActive === "1"
          );
          setWelcomeKit(activeItems);
          stopLoader();
        } else {
          setWelcomeKit([]);
          stopLoader();
        }
      })
      .catch((err) => {
        stopLoader();
        setWelcomeKit([]);
      });
  };

  const getItSetupList = () => {
    startLoader();
    utils
      .callAPI("get", `/employee/itsetup/list`, "")
      .then((res) => {
        if (typeof res !== "undefined") {
          const activeItems = res.result.filter(
            (item) => item.isActive === "1"
          );
          setItSetup(activeItems);
          stopLoader();
        } else {
          setItSetup([]);
          stopLoader();
        }
      })
      .catch((err) => {
        setItSetup([]);
        stopLoader();
      });
  };

  const handlePlanMultiSelect = (selectedList, selectedItem) => {
    const planIds = selectedList.map((item) => item.cat).join(",");
    setSelectedPlan(selectedList);
    setFormData({
      ...formData,
      onboard_plan: planIds,
    });
  };

  const handlePlanRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);

    const updatedOnboardPlan = formData.onboard_plan
      .split(",")
      .filter((id) => id !== removedId);

    setFormData({
      ...formData,
      onboard_plan: updatedOnboardPlan.join(","),
    });
  };

  const handleManagerMultiSelect = (selectedList, selectedItem) => {
    const managerIds = selectedList.map((item) => item.cat).join(",");
    setFormData({
      ...formData,
      reporting_manager: managerIds,
    });
  };

  const handleManagerRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);

    const updatedReportingManager = formData.reporting_manager
      .split(",")
      .filter((id) => id !== removedId);

    setFormData({
      ...formData,
      reporting_manager: updatedReportingManager.join(","),
    });
  };

  const handleKitMultiSelect = (selectedList, selectedItem) => {
    const kitIds = selectedList.map((item) => item.cat).join(",");
    setSelectedKit(selectedList);
    setFormData({
      ...formData,
      welcome_kit: kitIds,
    });
  };

  const handleKitRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);

    const updatedOnboardPlan = formData.welcome_kit
      .split(",")
      .filter((id) => id !== removedId);

    setFormData({
      ...formData,
      welcome_kit: updatedOnboardPlan.join(","),
    });
  };

  const handleItMultiSelect = (selectedList, selectedItem) => {
    const itIds = selectedList.map((item) => item.cat).join(",");
    setSelectedIt(selectedList);
    setFormData({
      ...formData,
      it_setup: itIds,
    });
  };

  const handleitRemove = (selectedList, removedItem) => {
    const removedId = String(removedItem.cat);

    const updatedOnboardPlan = formData.it_setup
      .split(",")
      .filter((id) => id !== removedId);
    setFormData({
      ...formData,
      it_setup: updatedOnboardPlan.join(","),
    });
  };

  const handleSelectChange = (e) => {
    const value = e.target.value;
    console.log("Selected holiday group:", value);
    setFormData({
      ...formData,
      holidayGroup: value,
    });
  };

  const renderHolidayGroupOptions = () => {
    return holidayGroups.map((group) => (
      <option key={group.id} value={group.id}>
        {group.group_name}
      </option>
    ));
  };

  const departmentOptions = department.map((dept) => ({
    value: dept.id,
    label: dept.department_name,
  }));

  const roleOptions = role.map((roleItem) => ({
    value: roleItem.id,
    label: roleItem.roleName,
  }));

  return (
    <>
      <h6 className="mt-2">On-boarding Information</h6>
      <hr className="hr-lg mt-1" />
      <RB.Row>
        <RB.Col md={6} className="mt-3">
          <Select
            options={departmentOptions}
            value={departmentOptions.find(
              (opt) => opt.value === formData.departmentId
            )}
            onChange={(selectedOption) =>
              handleInputChange({
                target: {
                  name: "departmentId",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            isClearable
            placeholder="Select Department"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 999999 }),
            }}
            classNamePrefix="react-select"
          />
        </RB.Col>

        <RB.Col md={6}>
          <div className="mb-3 mt-3">
            <RB.FloatingLabel
              label="Select Join Date"
              className={`floating-label-fancy ${
                formData.join_date ? "dateSelected" : "dateempty"
              }`}
            >
              <DatePicker
                selected={formData.join_date}
                onChange={(date) =>
                  setFormData({ ...formData, join_date: date })
                }
                dateFormat="dd-MM-yyyy"
                className="form-control"
                showMonthDropdown
                showYearDropdown
                dropdownMode="select"
                required
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>

        <RB.Col md={6} className="mt-3">
          <Select
            options={roleOptions}
            value={roleOptions.find((opt) => opt.value === formData.roleId)}
            onChange={(selectedOption) =>
              handleInputChange({
                target: {
                  name: "roleId",
                  value: selectedOption ? selectedOption.value : "",
                },
              })
            }
            isClearable
            placeholder="Select Designation"
            menuPortalTarget={document.body}
            styles={{
              menuPortal: (base) => ({ ...base, zIndex: 999999 }),
            }}
            classNamePrefix="react-select"
          />
        </RB.Col>

        <RB.Col md={6}>
          <div
            className={`mb-3 ${
              formData.reporting_manager.length !== 0 ? "" : "mt-4"
            }`}
          >
            <RB.FloatingLabel
              // label="Reporting Manager"
              className="floating-label-fancy"
            >
              <Multiselect
                name="reporting_manager"
                displayValue="key"
                id="reporting_manager_multiselect"
                onKeyPressFn={function noRefCheck() {}}
                onRemove={handleManagerRemove}
                onSearch={function noRefCheck() {}}
                onSelect={handleManagerMultiSelect}
                className={`${
                  formData.reporting_manager.length !== 0
                    ? "emp_multiselect"
                    : ""
                }`}
                options={manager.map((managerItem) => ({
                  cat: managerItem.id,
                  key: `${managerItem.firstName} ${managerItem.lastName}`,
                }))}
                selectedValues={manager
                  .filter((managerItem) =>
                    props?.rowData?.reporting_manager
                      .split(",")
                      .includes(managerItem.id.toString())
                  )
                  .map((managerItem) => ({
                    cat: managerItem.id,
                    key: `${managerItem.firstName} ${managerItem.lastName}`,
                  }))}
                placeholder="Select Reporting Managers.."
                customCloseIcon={
                  <>
                    <i className="material-icons-outlined md14 ms-1">cancel</i>
                  </>
                }
                style={{
                  chips: {
                    background: "#FFDE1B",
                    color: "#000000",
                    borderRadius: "1rem",
                    cursor: "pointer",
                  },
                  multiselectContainer: {
                    zIndex: 10000,
                    zIndex: 10000,
                  },
                  searchBox: {
                    border: "none",
                    borderBottom: "1px solid #dee2e6",
                    borderRadius: "0px",
                    fontWeight:
                      formData.reporting_manager.length > 0 ? "bold" : "normal",
                    fontWeight:
                      formData.reporting_manager.length > 0 ? "bold" : "normal",
                  },
                }}
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        {/* <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Designation"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Name"
                      name="Designation"
                      value={formData.Designation}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col> */}
        {/* <RB.Col md={6}>
                <div className="mb-3">
                  <RB.FloatingLabel
                    label="Designation"
                    className="floating-label-fancy"
                  >
                    <RB.Form.Control
                      type="text"
                      placeholder="Enter Name"
                      name="Designation"
                      value={formData.Designation}
                      onChange={handleInputChange}
                      required
                    />
                  </RB.FloatingLabel>
                </div>
              </RB.Col> */}
        <RB.Col md={6}>
          <div
            className={`mb-3 ${
              formData.onboard_plan.length !== 0 ? "" : "mt-4"
            }`}
          >
            <Multiselect
              //  hidePlaceholder
              required
              name="onboard_plan"
              displayValue="key"
              id="css_custom"
              onKeyPressFn={function noRefCheck() {}}
              onRemove={handlePlanRemove}
              onSearch={function noRefCheck() {}}
              onSelect={handlePlanMultiSelect}
              className={`${
                formData.onboard_plan.length !== 0 ? "emp_multiselect" : ""
              }`}
              options={onboardPlan.map((planItem) => ({
                cat: planItem.id,
                key: planItem.planName,
              }))}
              selectedValues={onboardPlan
                .filter((plan) =>
                  props?.rowData?.onboard_plan
                    .split(",")
                    .includes(plan.id.toString())
                )
                .map((plan) => ({ cat: plan.id, key: plan.planName }))}
              placeholder="Select on-board Plans.."
              customCloseIcon={
                <>
                  <i class="material-icons-outlined md14 ms-1">cancel</i>
                </>
              }
              style={{
                chips: {
                  background: "#FFDE1B",
                  color: "#000000",
                  borderRadius: "1rem",
                },
                multiselectContainer: {
                  zIndex: 10,
                },
                searchBox: {
                  border: "none",
                  borderBottom: "1px solid #dee2e6",
                  borderRadius: "0px",
                },
              }}
            />
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Training Schedule"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                as="select"
                name="training_schedule"
                value={formData.training_schedule}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Training Schedule</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </RB.Form.Control>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        {formData.training_schedule === "yes" && (
          <RB.Col md={6}>
            <div className="mb-3 mt-3">
              <RB.FloatingLabel
                label="Training Time"
                className={`floating-label-fancy ${
                  formData.training_time ? "dateSelected" : "dateempty"
                }`}
              >
                <DatePicker
                  selected={
                    formData.training_time instanceof Date &&
                    !isNaN(formData.training_time)
                      ? formData.training_time
                      : null
                  }
                  onChange={(date) =>
                    setFormData({ ...formData, training_time: date })
                  }
                  showTimeSelect
                  timeFormat="HH:mm"
                  timeIntervals={10}
                  timeCaption="time"
                  dateFormat="dd-MM-yyyy, h:mm aa"
                  className={`form-control`}
                  // showMonthDropdown
                  // showYearDropdown
                  dropdownMode="select"
                  // placeholderText="Select Date of Birth"
                  // maxDate={new Date()}
                />
              </RB.FloatingLabel>
            </div>
            {/* <div className="mb-3">
                    <RB.FloatingLabel
                      label="Training Time"
                      className="floating-label-fancy"
                    >
                      <RB.Form.Control
                        type="text"
                        name="training_time"
                        placeholder="Enter Last Name"
                        value={formData.training_time}
                        onChange={handleInputChange}
                        required
                      />
                    </RB.FloatingLabel>
                  </div> */}
          </RB.Col>
        )}
        <RB.Col md={6}>
          <div
            className={`mb-3 ${
              formData.welcome_kit.length !== 0 ? "" : "mt-4"
            }`}
          >
            <Multiselect
              // hidePlaceholder
              // hidePlaceholder
              name="welcome_kit"
              displayValue="key"
              id="css_custom"
              className={`${
                formData.welcome_kit.length !== 0 ? "emp_multiselect" : ""
              }`}
              onKeyPressFn={function noRefCheck() {}}
              onRemove={handleKitRemove}
              onSearch={function noRefCheck() {}}
              onSelect={handleKitMultiSelect}
              options={welcomeKit.map((kit) => ({
                cat: kit.id,
                key: kit.name,
              }))}
              selectedValues={
                isEdit
                  ? welcomeKit
                      .filter((plan) =>
                        props.rowData.welcome_kit
                          .split(",")
                          .includes(plan.id.toString())
                      )
                      .map((plan) => ({ cat: plan.id, key: plan.name }))
                  : ""
              }
              placeholder="Select welcome kit.."
              customCloseIcon={
                <>
                  <i class="material-icons-outlined md14 ms-1">cancel</i>
                </>
              }
              style={{
                chips: {
                  background: "#FFDE1B",
                  color: "#000000",
                  borderRadius: "1rem",
                },
                multiselectContainer: {
                  zIndex: 5,
                },
                searchBox: {
                  border: "none",
                  borderBottom: "1px solid #dee2e6",
                  borderRadius: "0px",
                },
              }}
            />
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div
            className={`mb-3 ${formData.it_setup.length !== 0 ? "" : "mt-4"}`}
          >
            <Multiselect
              // hidePlaceholder
              // hidePlaceholder
              name="it_setup"
              displayValue="key"
              id="css_custom"
              onKeyPressFn={function noRefCheck() {}}
              onRemove={handleitRemove}
              className={`${
                formData.it_setup.length !== 0 ? "emp_multiselect" : ""
              }`}
              onSearch={function noRefCheck() {}}
              onSelect={handleItMultiSelect}
              options={itSetup.map((it) => ({
                cat: it.id,
                key: it.name,
              }))}
              selectedValues={
                isEdit
                  ? itSetup
                      .filter((plan) =>
                        props.rowData.it_setup
                          .split(",")
                          .includes(plan.id.toString())
                      )
                      .map((plan) => ({ cat: plan.id, key: plan.name }))
                  : ""
              }
              placeholder="Select it setup.."
              customCloseIcon={
                <>
                  <i class="material-icons-outlined md14 ms-1">cancel</i>
                </>
              }
              style={{
                chips: {
                  background: "#FFDE1B",
                  color: "#000000",
                  borderRadius: "1rem",
                },
                multiselectContainer: {
                  zIndex: 5,
                },
                searchBox: {
                  border: "none",
                  borderBottom: "1px solid #dee2e6",
                  borderRadius: "0px",
                },
              }}
            />
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel label="Grade" className="floating-label-fancy">
              <RB.Form.Control
                type="text"
                placeholder="Enter Grade"
                name="grade"
                value={formData.grade}
                onChange={handleInputChange}
                required
              />
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Employee Handbook"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                as="select"
                name="emp_handbook"
                value={formData.emp_handbook}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Employee Handbook</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </RB.Form.Control>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Medical Disability"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                as="select"
                name="medical_disabillity"
                value={formData.medical_disabillity}
                onChange={handleInputChange}
                required
              >
                <option value="">Select Medical Disability</option>
                <option value="yes">Yes</option>
                <option value="no">No</option>
              </RB.Form.Control>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        {formData.medical_disabillity == "yes" && (
          <RB.Col md={6}>
            <div className="mb-3">
              <RB.FloatingLabel
                label="Medical Disability"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  type="text"
                  placeholder="Enter Medical Disability"
                  name="medical_disabillity_remark"
                  value={formData.medical_disabillity_remark}
                  onChange={handleInputChange}
                  required
                />
              </RB.FloatingLabel>
            </div>
          </RB.Col>
        )}

        <RB.Col md={6}>
          <div className="mb-3">
            <RB.FloatingLabel
              label="Select Holiday Group"
              className="floating-label-fancy"
            >
              <RB.Form.Control
                as="select"
                name="holidayGroup"
                value={formData.holidayGroup}
                onChange={handleSelectChange}
                required
              >
                <option value="">Select Holiday Group...</option>

                {renderHolidayGroupOptions()}
              </RB.Form.Control>
            </RB.FloatingLabel>
          </div>
        </RB.Col>
        <RB.Col md={6}>
          <div className="mb-3">
            <RB.InputGroup>
              <RB.FloatingLabel
                label="Probation Period"
                className="floating-label-fancy"
              >
                <RB.Form.Control
                  type="text"
                  placeholder="Enter Probation Period"
                  name="probation_period"
                  inputMode="numeric"
                  value={formData.probation_period}
                  onChange={handleInputChange}
                  onInput={(e) => {
                    let value = e.target.value.replace(/[^0-9]/g, "");

                    if (value !== "") {
                      const numericValue = parseInt(value, 10);
                      if (numericValue < 1) {
                        value = "1";
                      } else if (numericValue > 12) {
                        value = "12";
                      } else {
                        value = numericValue.toString();
                      }
                    }
                    e.target.value = value;
                  }}
                  required
                />
              </RB.FloatingLabel>
              <RB.InputGroup.Text
                id="months"
                className="border border-top-0 border-end-0"
              >
                Month
              </RB.InputGroup.Text>
            </RB.InputGroup>
          </div>
        </RB.Col>
      </RB.Row>
    </>
  );
}

export default OnBoardInfo;
